import { ICONS } from './icons';

// The left menu for a single provider, shared by its pages so the submenu does
// not vanish when moving between them (the sidebar shows the console nav again
// as soon as a page publishes nothing).
//
// Items are exact-path links, which is what the sidebar's active check expects.
export const providerNav = (provider) => {
  const id = provider?.id;
  return {
    title: provider?.name || 'Provider',
    crumb: provider?.shortName || 'Provider',
    subtitle: provider?.shortName,
    backTo: '/providers',
    items: [
      { label: 'Overview', to: `/providers/${id}`, icon: ICONS.providers },
      {
        label: 'Region subscriptions',
        to: `/providers/${id}/regions`,
        icon: ICONS.regions,
      },
      {
        label: 'Compartments',
        to: `/providers/${id}/compartments`,
        icon: ICONS.compartments,
      },
      {
        label: 'Public price list',
        to: `/providers/${id}/price-list`,
        icon: ICONS.prices,
      },
      {
        label: 'Price sync history',
        to: `/providers/${id}/price-list/history`,
        icon: ICONS.history,
      },
    ],
  };
};

export default providerNav;
